import { useEffect, useState } from "react";
import { FileCheck2, AlertTriangle, X } from "lucide-react";

// NotaToastStack: renderiza toasts customizados de notas fiscais no canto
// superior esquerdo (separado do sonner que fica em top-right para boletos).
// Cada toast dura 5s e é dismissível manualmente.
export default function NotaToastStack() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const onShow = (e) => {
      const d = e?.detail;
      if (!d) return;
      const id = d.id || `${Date.now()}-${Math.random()}`;
      setToasts((prev) => {
        if (prev.some((t) => t.id === id)) return prev;
        return [...prev, { ...d, id }];
      });
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 5000);
    };
    window.addEventListener("show-nota-toast", onShow);
    return () => window.removeEventListener("show-nota-toast", onShow);
  }, []);

  const dismiss = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

  if (toasts.length === 0) return null;

  return (
    <div data-nota-toast-stack
         style={{ position: "fixed", top: "72px", right: "16px",
                  zIndex: 9999, display: "flex", flexDirection: "column",
                  gap: "6px", maxWidth: "300px", pointerEvents: "none" }}>
      {toasts.map((t) => {
        const st = t.status || "autorizada";
        const isOk = st === "autorizada";
        const isCancel = st === "cancelada";
        const cor = isOk
          ? { bg: "bg-emerald-50", border: "border-emerald-300",
              text: "text-emerald-900", ic: "text-emerald-600" }
          : isCancel
          ? { bg: "bg-amber-50", border: "border-amber-300",
              text: "text-amber-900", ic: "text-amber-600" }
          : { bg: "bg-rose-50", border: "border-rose-300",
              text: "text-rose-900", ic: "text-rose-600" };
        return (
          <div key={t.id}
               data-testid={`nota-toast-${t.id}`}
               style={{ pointerEvents: "auto",
                        animation: "slideInRight 0.25s ease-out" }}
               className={`${cor.bg} ${cor.border} border rounded-lg shadow-md px-3 py-2 flex items-start gap-2`}>
            <div className={`${cor.ic} pt-0.5 shrink-0`}>
              {isOk ? <FileCheck2 className="w-4 h-4" />
                    : <AlertTriangle className="w-4 h-4" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className={`text-[12px] font-semibold ${cor.text} leading-tight truncate`}>
                {t.titulo}
              </div>
              <div className={`text-[10px] ${cor.text} opacity-70 leading-tight mt-0.5 truncate`}>
                {t.desc}
              </div>
            </div>
            {t.rota && (
              <button onClick={() => { window.location.href = t.rota; }}
                      className={`text-[10px] ${cor.text} underline hover:no-underline shrink-0 self-center`}>
                Ver
              </button>
            )}
            <button onClick={() => dismiss(t.id)}
                    className="text-slate-400 hover:text-slate-700 shrink-0 self-center">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
